import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import IconButton from 'components/icon-button'

import PlusIcon from '../../../assets/icons/plus.svg'

import GridSidebarSellableItem from './grid-sidebar-sellable-item'

import styles from './grid-sidebar.css'

const GridSidebar = ({ sellableItems, onAddTicket }) => (
  <div styleName="container">
    <div styleName="add-ticket" onClick={onAddTicket}>
      <IconButton label="Ticket">
        <PlusIcon />
      </IconButton>
    </div>
    <div>
      {sellableItems.valueSeq().map(sellableItem =>
        <GridSidebarSellableItem key={sellableItem.id} sellableItem={sellableItem} />
      )}
    </div>
  </div>
)

GridSidebar.propTypes = {
  sellableItems: PropTypes.object.isRequired,
  onAddTicket: PropTypes.func.isRequired,
}

export default CSSModules(GridSidebar, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-sidebar/grid-sidebar.js
 **/